import {
  PartyForCard,
  getDescriptionString,
  getSeatingAreaName,
  getTicketType,
} from 'components/service/party/partyRedesignCard/partyType';
import { isTicketTypeDiningVariety } from '@tock/shared/utils/offerings';
import { shouldHideAllSeatingAreasSelector } from 'selectors/service/shouldHideAllSeatingAreasSelector';
import { useSelector } from 'react-redux';

export function useReservationDescription(party: PartyForCard) {
  const shouldHideAllSeatingAreas = useSelector(shouldHideAllSeatingAreasSelector);

  const seatingAreaUnformattedName = getSeatingAreaName(party);
  const hasSeatingArea = seatingAreaUnformattedName !== '';
  const showSeatingAreaText =
    hasSeatingArea && !shouldHideAllSeatingAreas && isTicketTypeDiningVariety(getTicketType(party));

  const descriptionString = getDescriptionString(party);
  const seatingAreaDisplayName = showSeatingAreaText
    ? `${descriptionString ? ' · ' : ''}${seatingAreaUnformattedName}`
    : '';

  return { descriptionString, seatingAreaDisplayName };
}
